import CourseAccordion from 'Views/Components/CourseAccordion/CourseAccordion';
import CourseAccordionItem from 'Views/Components/CourseAccordion/CourseAccordionItem';
import CourseAccordionLabel from 'Views/Components/CourseAccordion/CourseAccordionLabel';

export default {
	Accordion: CourseAccordion,
	Item: CourseAccordionItem,
	Label: CourseAccordionLabel,
};
